<template>
  <el-dialog :title="popType === 'add' ? ( meterType === '1' ? '新增水表记录' : '新增电表记录' ) : (  meterType === '1' ? '修改水表记录' : '修改电表记录' )"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-card shadow="none">
      <el-col :span="24">
        <el-form :model="checkInData"
                 :rules="checkInRules"
                 ref="checkInForm"
                 label-width="125px"
                 class="checkin-form">

          <el-form-item label="数值:"
                        prop="meter_value">
            <div style="display: flex; align-items: center; gap: 10px;">
              <el-input style="max-width: 217px;"
                        v-model.trim="checkInData.meter_value"
                        placeholder="数值">
              </el-input>
              <span v-if="meterType === '1'">㎡（平方米）</span>
              <span v-else-if="meterType === '2'">kw/h(度)</span>
              <span v-else>未知</span>
            </div>
          </el-form-item>

          <el-form-item v-if="popType === 'add'"
                        label="区域:"
                        prop="area_id">
            <el-select v-model="checkInData.area_id"
                       placeholder="请选择所属区域"
                       @change="areaSelChange">
              <el-option v-for="item in areaList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="popType === 'add'"
                        label="房间:"
                        prop="room_id">
            <el-select v-model="checkInData.room_id"
                       placeholder="请选择房间">
              <el-option v-for="item in roomList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="抄表时间:"
                        prop="read_dt">
            <el-date-picker v-model="checkInData.read_dt"
                            format="yyyy-MM-dd hh:mm:ss"
                            value-format="yyyy-MM-dd hh:mm:ss"
                            type="datetime"
                            placeholder="选择日期时间"
                            align="right">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="备注:"
                        prop="remark">
            <el-input v-model.trim="checkInData.remark"
                      placeholder="备注">
            </el-input>
          </el-form-item>

        </el-form>
      </el-col>
    </el-card>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm('checkInForm')">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    popType: {
      type: String
    },
    editData: {
      type: Object
    },
    areaList: {},
    meterType: {
      type: String
    }
  },
  data() {
    return {
      showModal: this.isShow,
      roomList: [],
      checkInData: {
        area_id: '',
        room_id: '',
        // meter_type 1-水表 2-电表
        meter_value: '',
        read_dt: '',
        remark: ''
      },
      checkInRules: {
        area_id: [{ required: true, message: '请选择区域' }],
        room_id: [{ required: true, message: '请选择房间' }],
        meter_value: [{ required: true, message: '请输入数值' }],
        read_dt: [{ required: true, message: '请选择抄表时间' }]
      }
    }
  },
  created() {},
  mounted() {
    if (this.popType === 'add') {
      this.checkInData.read_dt = new Date()
    } else {
      this.checkInData.meter_value = this.editData.meter_value
      this.checkInData.read_dt = this.editData.read_dt
      this.checkInData.remark = this.editData.remark
    }
  },
  methods: {
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //this.checkInData.read_dt = utils.format(this.checkInData.read_dt, 'yyyy-MM-dd hh:mm:ss')
          if (this.popType === 'add') {
            fetch.addMeterRead({ ...this.checkInData, meter_type: this.meterType }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch
              .editMeterRead({
                id: this.editData.id,
                meter_value: this.checkInData.meter_value,
                read_dt: this.checkInData.read_dt,
                remark: this.checkInData.remark,
                meter_type: this.meterType
              })
              .then((data) => {
                data.procData(
                  data.res,
                  () => {
                    this.$message.success('操作成功')
                    this.handleCancel('refresh')
                  },
                  (err) => {
                    this.$message.error(err)
                  }
                )
              })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(val) {
      this.$emit('handleClose', val)
    },
    //区域选择联动设备筛选
    areaSelChange(val) {
      this.roomList = []
      this.checkInData.room_id = ''
      fetch.getRoomList({ area_id: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style></style>
